export const chapters = [
  {
    n: "01",
    kicker: "The Origin",
    title: "Created by a woman. Designed for women.",
    img: "/sash/egypt-pyramids.webp",
    side: "right",
    body: [
      "Sash wasn't born in a fashion house. It wasn't designed by people chasing trends. It was created by a woman who was simply tired of fighting with her purse.",
      "The slipping strap. The bottomless pit. The sore neck. The aching back. The constant digging for keys while juggling groceries, coffee, luggage, kids, dogs — or all of the above.",
      "After years of sketching, prototyping, testing and refining, Sash became a patented design unlike anything else on the market. Not because it looks different. Because it works differently.",
    ],
  },
  {
    n: "02",
    kicker: "The Secret",
    title: "It's not just more pockets. It's where they are.",
    img: "/sash/amber-fringe.jpg",
    side: "left",
    body: [
      "Most handbags become one large compartment where everything settles into a single heavy pile. Sash was designed from the inside out.",
      "Its patented system of 10 ergonomic pockets wraps naturally around your body, letting your belongings spread out instead of collecting into one heavy mass.",
      "You fill it. Zip it. Put it on. And suddenly the weight seems to disappear. That's the magic women talk about.",
    ],
  },
  {
    n: "03",
    kicker: "Everything Has a Home",
    title: "Reach for your phone — without looking.",
    img: "/sash/what-fits.png",
    side: "right",
    body: [
      "Sunglasses. Wallet. Passport. Lipstick. Keys. AirPods. Reading glasses. Hand sanitizer. Everything has a place.",
      "Not because someone added more pockets — because someone finally put them where your hands naturally expect them to be.",
      "Organization becomes effortless. Your mind becomes quieter. And for the first time in a long time, your purse isn't something you have to think about.",
    ],
  },
  {
    n: "04",
    kicker: "The Freedom",
    title: "Freedom looks different than you expected.",
    img: "/sash/lifestyle-brown-fringe.jpg",
    side: "left",
    body: [
      "The first thing you'll notice isn't the pockets, or the leather, or even how beautiful it is. You'll notice yourself.",
      "Walking through the airport without adjusting your bag. Holding your granddaughter's hand. Helping your father steady himself. Taking photos on vacation. Walking your dog. Exploring a new city.",
      "Living with two free hands. It's amazing how much freedom can come from one thoughtful design.",
    ],
  },
];

export const features = [
  "Patented ergonomic design",
  "10 thoughtfully organized pockets",
  "Hands-free comfort",
  "Weight distributed across your body, not one shoulder",
  "Beautiful premium materials",
  "Built to last for years",
  "Designed by a woman who understood the problem",
  "Loved by women around the world",
];

export const testimonials = [
  { quote: "I've had several comments on this bag. People stop me and ask where I got it. Everyone likes how close it fits to the body. Love the many pockets.", name: "Linda L." },
  { quote: "The pockets are wonderful. A great bag that evenly distributes the weight. This bag doesn't make your back, shoulders or neck hurt!", name: "Cindy" },
  { quote: "I have two titanium plates in my spine and this is the only bag that doesn't bother my neck or spine. First crossbody I have that doesn't hurt my spine!", name: "Andrea M." },
  { quote: "Everyone loves my Sash bags! I hand out Sash cards everywhere I go. Keeping my hands free helps me steady my father when he stumbles.", name: "Tammy T." },
  { quote: "I have two Sash bags I've had for years and they're still in excellent condition. I'm going to get more.", name: "Lisa" },
];

export const colors = [  { img: "/sash/mukisa-fringe.jpg", name: "Mukisa Leather Fringe" },
  { img: "/sash/musana-leather.jpg", name: "Musana Leather" },
  { img: "/sash/mulunji.jpg", name: "Mulunji" },
  { img: "/sash/suubi-fringe.jpg", name: "Suubi Fringe" },
];

export const sisters = [
  { img: "/sash/ss1.jpg", caption: "Sisterhood, in full color" },
  { img: "/sash/ss5.jpg", caption: "Hands free at the farmers market" },
  { img: "/sash/ss2.jpg", caption: "Everyday errands, everywhere" },
  { img: "/sash/ss3.jpg", caption: "Walking beside you through Paris" },
  { img: "/sash/ss4.jpg", caption: "Adventures across the world" },
  { img: "/sash/ss6.jpg", caption: "Sash Sisters, out in the wild" },
  { img: "/sash/ss7.jpg", caption: "Hands free, everywhere they go" },
  { img: "/sash/ss8.jpg", caption: "Living the Sash life" },
  { img: "/sash/ss9.jpg", caption: "Good bags, good friends" },
  { img: "/sash/ss10.jpg", caption: "Everyday moments, made easier" },
  { img: "/sash/ss11.jpg", caption: "The sisterhood, out and about" },
  { img: "/sash/ss12.jpg", caption: "Carrying life, hands free" },
  { img: "/sash/ss13.jpg", caption: "Proud to be a Sash Sister" },
];

export const collectionSlides = [
  { img: "/sash/col3.jpg", caption: "Even the pup knows a good collection" },
  { img: "/sash/col1.jpg", caption: "A color for every mood" },
  { img: "/sash/col4.jpg", caption: "Leathers, textures & fringe" },
  { img: "/sash/col2.jpg", caption: "The full spectrum, wall to wall" },
  { img: "/sash/col5.jpg", caption: "Rich jewel tones & warm neutrals" },
];
